import { forwardRef } from "react"
import { cn } from "@/utils/styles"

export interface BaseIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
  className?: string
}

/**
 * Base icon component that provides consistent styling and behavior
 * for all custom icons in the application.
 */
export const BaseIcon = forwardRef<SVGSVGElement, BaseIconProps>(({ size = 24, className, children, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="0.5"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("inline-block", className)}
      {...props}>
      {children}
    </svg>
  )
})

BaseIcon.displayName = "BaseIcon"
